import React from "react";
import { Badge } from "./ui/badge";
import { Award, Users, Wrench, Heart } from "lucide-react";
import { aboutImage, bayImage } from "../data/mock";

const pillars = [
  { icon: Award, title: "STAR Certified", text: "California Bureau of Automotive Repair certified station." },
  { icon: Users, title: "Family Owned", text: "Locally owned and family-operated since 2021." },
  { icon: Wrench, title: "Expert Techs", text: "Certified technicians for gas, diesel, hybrid & classics." },
  { icon: Heart, title: "Veteran Friendly", text: "Discounts and recognition for veterans and seniors." }
];

const About = () => {
  return (
    <section id="about" className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-xl border border-slate-200 aspect-[4/5]">
              <img src={aboutImage} alt="Hamilton's Smog technicians at work" className="w-full h-full object-cover" />
            </div>
            <div className="hidden md:block absolute -bottom-8 -right-8 w-56 h-56 rounded-2xl overflow-hidden shadow-2xl border-4 border-white">
              <img src={bayImage} alt="Smog check bay" className="w-full h-full object-cover" />
            </div>
            <div className="hidden md:block absolute -top-6 -left-6 bg-green-600 text-white rounded-xl px-5 py-3 shadow-xl">
              <div className="text-2xl font-black leading-none">2021</div>
              <div className="text-xs font-medium mt-1 uppercase tracking-wider">Serving Novato</div>
            </div>
          </div>

          <div>
            <Badge className="bg-green-50 text-green-700 border border-green-200 hover:bg-green-50 mb-4">About Us</Badge>
            <h2 className="text-3xl md:text-5xl font-black text-slate-900 tracking-tight leading-tight">A small business built on trust, speed &amp; honest pricing.</h2>
            <p className="text-slate-600 mt-5 text-lg leading-relaxed">
              Hamilton's Star Smog Check is a family-owned smog station in downtown Novato dedicated to making your vehicle registration renewal fast and stress-free. Our two-bay shop and certified technicians serve every corner of Marin County with a welcoming, professional environment.
            </p>
            <p className="text-slate-600 mt-3 text-lg leading-relaxed">
              If you need help paying for a smog check, please talk to us — we will do our best to help. Veterans and seniors, thank you for your service; ask about your discount at check-in.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              {pillars.map((p) => (
                <div key={p.title} className="flex gap-4 p-4 rounded-xl border border-slate-200 card-hover bg-slate-50">
                  <div className="w-11 h-11 rounded-lg bg-slate-900 text-white grid place-items-center flex-shrink-0">
                    <p.icon className="w-5 h-5" />
                  </div>
                  <div>
                    <div className="font-black text-slate-900">{p.title}</div>
                    <div className="text-sm text-slate-600 mt-0.5">{p.text}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
